import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "btn-import" }
const _hoisted_2 = {
  for: "import-input",
  class: "flex cursor-pointer"
}
const _hoisted_3 = { class: "text-[14px] ml-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Button, {
      class: _normalizeClass(`${_ctx.btnStyle} p-button-sm`),
      disabled: _ctx.btnDisabled
    }, {
      default: _withCtx(() => [
        _createElementVNode("label", _hoisted_2, [
          _createVNode(_component_v_icon, { name: _ctx.btnIcon }, null, 8, ["name"]),
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.name), 1)
        ])
      ]),
      _: 1
    }, 8, ["class", "disabled"]),
    _createElementVNode("input", {
      id: "import-input",
      type: "file",
      accept: ".csv",
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onUpload && _ctx.onUpload(...args))),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.inputReset($event))),
      hidden: ""
    }, null, 32)
  ]))
}